<template>
<div class="index">
    <div class="left">
        <indexCurrency v-if="user.systypecode==1" @setMpqrcode="_setMpqrcode"></indexCurrency>
        <ordinaryIndex v-if="user.systypecode==2 || user.systypecode==3"></ordinaryIndex>
    </div>
    <div class="right">
        <div class="shop box-shadow">
            <img :src="shop.shoplogourl ? shop.shoplogourl : logo" alt="logo">
            <div class="name">{{shop.shopname}}</div>
            <!--<div class="btn">标准版</div>-->
        </div>
        <div class="service box-shadow">
            <div class="tip">我们随时提供帮助</div>
            <div class="tel blod" v-if="user.systypecode==1 || user.systypecode==3">17722476069</div>
            <div class="tel blod" v-if="user.systypecode==2">0755-86393160</div>
            <!--<div class="consultation"><div>在线咨询</div></div>-->
            <a v-if="user.systypecode==2" href="https://shimo.im/docs/a3072f72b92f42f8/read" target="_blank"><div class="consultation"><div>操作文档</div></div></a>
            <div class="wechat-public-number" v-if="user.systypecode==1 || user.systypecode==3">
                <div class="tip">关注客服二维码</div>
                <img :src="serviceCodeUrl" alt="客服二维码">
            </div>
            <div class="wechat-public-number" v-if="user.systypecode==2">
                <div class="tip">关注公众号</div>
                <img  :src="prCodeUrlCC" alt="公众号">
            </div>
            <div class="wechat-public-number" v-if="user.systypecode==1 && prCodeUrlJKT">
                <div class="tip">关注公众号</div>
                <img :src="prCodeUrlJKT" alt="公众号">
            </div>
        </div>
    </div></div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import IndexCurrency from 'views/index/components/indexCurrency.vue'
import OrdinaryIndex from 'views/index/components/ordinaryIndex.vue'
export default {
    name: 'index',
    data() {
        return {
            prCodeUrlCC: 'http://img.capwhale.com/zjffh.jpg',//资鲸
            prCodeUrlJKT: "",
            serviceCodeUrl: "http://img.jingketong.cn/mp/jkt/jkt_hdt_servicecode.jpg",
        }
    },
    created() {

    },
    mounted() {
    },
    methods: {
        _setMpqrcode(url) {
            this.prCodeUrlJKT = url
        }
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'shop',
            'domain'
        ])
    },
    components: {
        IndexCurrency, OrdinaryIndex
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/icon";
@import "~common/scss/mixin";
    .index{
        display: flex;
        .left{
            flex-grow: 1;
        }
        .right {
            width: 250px;
            margin-left:25px;
            text-align: center;
            align-self: flex-start;
            .shop{
                padding:20px 0;
                background: $tcolor-white;
                img{
                    width: 68px;
                    height: 68px;
                }
                .name{
                    margin-top:10px;
                }
                .btn{
                    background: $bgcolor-base;
                    height: 40px;
                    line-height: 40px;
                    color: $tcolor-white;
                }
            }
            .service{
                margin-top: 15px;
                background: $tcolor-white;
                padding: 20px 0;
                font-size: $font-16;
                .tel{
                    color: $tcolor-blue;
                    font-size: $font-24;
                    padding: 15px 0;
                }
                .consultation{
                    div{
                        margin: auto;
                        border: 1px solid $line;
                        border-radius: 22px;
                        width: 130px;
                        height: 30px;
                        line-height: 30px;
                        font-size: $font-14;
                        color: $tcolor-gray;
                    }
                    margin-bottom: 35px;
                }
                .wechat-public-number{
                    border-top: 1px solid $line;
                    .tip{
                        padding: 20px 0 15px 0;
                        font-size: $font-16;
                    }
                    img{
                        width: 167px;
                        height: 167px;
                    }
                }
            }
        }
    }
</style>
